import React, { Fragment } from 'react';
import { List, ListItem, ListItemText, Typography, } from '@material-ui/core';
import { Filters } from './../services/Filters';

const _filters = new Filters();

export const NoticeDetail = (props) => {

  const { translations, appLanguage } = props;
  const meetings = props.noticeItem.meetings ? props.noticeItem.meetings : [];
  const general = props.noticeItem.general ? props.noticeItem.general : [];
  const records = props.noticeItem.records ? props.noticeItem.records : [];
  return (
    <Fragment>
      {/* Manual/iCal notices */}
      <List>
        {records.map((record, i) => {
          return (
            <ListItem divider key={i}>
              <ListItemText
                primary={
                  <Fragment>
                    <h3>{record.header}</h3>
                  </Fragment>
                }
                secondary={_filters.nl2br(record.description)}
              />
            </ListItem>
          )
        })}
      </List>
      {/* kamar notices */}
      { meetings.length > 0 ?
        <Typography>
          {translations.t_TITLE_NOTICE_KAMAR_MEETING[appLanguage]}
        </Typography>
      : null
      }
      <List>
        {meetings.map(meeting => {
          return (
            <ListItem divider key={meeting.header+meeting.date}>
              <ListItemText
                primary={
                  <Fragment>
                    <h3>{meeting.header} {meeting.level ? <span>( {meeting.level} )</span> : null }</h3>
                    <p> {meeting.place} - {_filters.startEndDate(meeting.date)} - {meeting.teacher}</p>
                  </Fragment>
                }
                secondary={_filters.nl2br(meeting.description)}
              />
            </ListItem>
          )
        })}
      </List>
      { general.length > 0 ?
        <Typography>
          {translations.t_TITLE_NOTICE_KAMAR_GENERAL[appLanguage]}
        </Typography>
      : null
      }
      <List>
        {general.map((item, i) => {
          return (
            <ListItem divider key={item.header+i}>
              <ListItemText
                primary={
                  <Fragment>
                    <h3>{item.header} - {item.type} <span>( {item.level} )</span></h3>
                    {item.teacher ? <p>{item.teacher}</p> : null }
                  </Fragment>
                }
                secondary={_filters.nl2br(item.description)}
              />
            </ListItem>
          )
        })}
      </List>
    </Fragment>
  )
}


// WEBPACK FOOTER //
// ./src/components/NoticeDetail.js